import { render } from "./WebLayout2.vue?vue&type=template&id=334c48fa&scoped=true&class=true"
import script from "./WebLayout2.vue?vue&type=script&lang=js"
export * from "./WebLayout2.vue?vue&type=script&lang=js"

import "./WebLayout2.vue?vue&type=style&index=0&id=334c48fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334c48fa"]])

export default __exports__